var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex", attrs: { id: "client-base" } }, [
    _vm.pageLoading
      ? _c("div", { staticClass: "fixed z-50 w-screen h-screen top-18" }, [
          _c("div", {
            staticClass: "absolute w-full h-full opacity-75 bg-pure-white"
          }),
          _vm._v(" "),
          _vm._m(0)
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex flex-col flex-grow" },
      [
        _vm.redirectTarget
          ? _c(
              "div",
              {
                staticClass:
                  "sticky left-0 z-50 flex items-center flex-shrink-0 h-10 px-6 border-b border-slate-400 bg-pure-white",
                style: { width: "calc(100vw - 0.5rem)" }
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "flex items-center gap-2",
                    attrs: { to: _vm.redirectTarget }
                  },
                  [
                    _c("BlIcon", {
                      staticClass: "w-6 h-6",
                      attrs: { icon: "chevron-left" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "capitalize-first",
                      attrs: {
                        text:
                          _vm.redirectLabel ||
                          _vm.redirectTarget.replaceAll("/", " ")
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "sticky left-0 flex items-center justify-between flex-shrink-0 h-12 gap-4 px-6 bg-pure-white",
            style: { zIndex: 51, width: "calc(100vw - 0.5rem)" },
            attrs: { id: "client-header" }
          },
          [
            _c("BlBreadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } }),
            _vm._v(" "),
            _vm.client
              ? _c(
                  "div",
                  { staticClass: "h-7.5 flex items-center justify-end gap-4" },
                  [
                    _vm.client.accesses && _vm.client.accesses.length
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-4" },
                          [
                            _c("BlIcon", {
                              staticClass: "w-6 h-6",
                              attrs: { icon: "people-therapist" }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.client.accesses.slice(0, 3), function(
                              access
                            ) {
                              return _c(
                                "div",
                                {
                                  key: access.id,
                                  staticClass: "hidden lg:block"
                                },
                                [
                                  access.user_id
                                    ? _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            event: _vm.currentUser.role.includes(
                                              "admin"
                                            )
                                              ? "click"
                                              : "",
                                            target: "_blank",
                                            to: {
                                              name: "TeamSessionHistory",
                                              params: {
                                                user_id: access.user_id,
                                                redirect_target:
                                                  "/clients/" + _vm.client.id,
                                                redirect_label: "Client profile"
                                              }
                                            }
                                          }
                                        },
                                        [
                                          access.user && access.user.name
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex flex-wrap items-center flex-shrink-0 h-8 px-2 truncate border rounded bg-success-100 border-success-100 max-w-64",
                                                  class: _vm.currentUser.role.includes(
                                                    "admin"
                                                  )
                                                    ? "hover:border-success-400"
                                                    : "cursor-default"
                                                },
                                                [
                                                  _c("BlTextBody2", {
                                                    staticClass:
                                                      "truncate text-success",
                                                    attrs: {
                                                      text: access.user.name
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _vm.client.accesses.slice(
                              _vm.viewMode === "desktop" ? 3 : 0
                            ).length
                              ? _c("div", { staticClass: "relative" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex items-center justify-center cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          _vm.openMoreTherapist = !_vm.openMoreTherapist
                                        }
                                      }
                                    },
                                    [
                                      _c("BlBubbleCount", {
                                        staticClass:
                                          "h-7 hover:bg-light-purple-100",
                                        attrs: {
                                          count:
                                            "+ " +
                                            _vm.client.accesses.slice(
                                              _vm.viewMode === "desktop" ? 3 : 0
                                            ).length
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.openMoreTherapist
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "absolute top-0 left-0 z-50 flex flex-col gap-1 p-1 mt-10 truncate border rounded lg:right-0 bg-pure-white border-grey-200 min-w-40"
                                        },
                                        _vm._l(
                                          _vm.client.accesses.slice(
                                            _vm.viewMode === "desktop" ? 3 : 0
                                          ),
                                          function(access) {
                                            return _c(
                                              "div",
                                              {
                                                key: access.id,
                                                staticClass:
                                                  "flex-grow max-w-64"
                                              },
                                              [
                                                access.user_id
                                                  ? _c(
                                                      "router-link",
                                                      {
                                                        attrs: {
                                                          event: _vm.currentUser.role.includes(
                                                            "admin"
                                                          )
                                                            ? "click"
                                                            : "",
                                                          target: "_blank",
                                                          to: {
                                                            name:
                                                              "TeamSessionHistory",
                                                            params: {
                                                              user_id:
                                                                access.user_id,
                                                              redirect_target:
                                                                "/clients/" +
                                                                _vm.client.id,
                                                              redirect_label:
                                                                "Client profile"
                                                            }
                                                          }
                                                        }
                                                      },
                                                      [
                                                        access.user &&
                                                        access.user.name
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "px-4 py-2 text-left truncate rounded",
                                                                class: [
                                                                  _vm.currentUser.role.includes(
                                                                    "admin"
                                                                  )
                                                                    ? "hover:bg-hover-state"
                                                                    : "cursor-default"
                                                                ],
                                                                attrs: {
                                                                  title:
                                                                    access.user
                                                                      .name
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "BlTextBody2",
                                                                  {
                                                                    staticClass:
                                                                      "truncate text-grey",
                                                                    attrs: {
                                                                      text:
                                                                        access
                                                                          .user
                                                                          .name
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentUser.role.includes("admin")
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "relative flex items-center flex-shrink-0 gap-4"
                          },
                          [
                            _c("div", {
                              staticClass: "h-7.5 w-0.5 rounded bg-slate-400"
                            }),
                            _vm._v(" "),
                            _c("BlInputButton", {
                              attrs: {
                                type: "outlined",
                                dense: "",
                                label: "Assign therapist"
                              },
                              on: { clicked: _vm.onOpenManageTherapist }
                            }),
                            _vm._v(" "),
                            _c("BlInputButton", {
                              staticClass:
                                "flex items-center justify-center w-8 h-8 hover:bg-hover-state",
                              attrs: { icon: "dots-vertical", type: "plain" },
                              on: {
                                clicked: function($event) {
                                  _vm.menuOpened = !_vm.menuOpened
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.menuOpened
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "absolute right-0 z-50 p-1 mt-2 space-y-1 border rounded top-full bg-pure-white border-grey-200"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "px-4 py-2 text-left rounded outline-none hover:bg-hover-state min-w-32",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.deleteOpened = true
                                          }
                                        }
                                      },
                                      [
                                        _c("BlTextBody2", {
                                          staticClass: "text-error-400",
                                          attrs: { text: "Delete client" }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.manageTherapistOpened
          ? _c(
              "BlBackdrop",
              {
                attrs: {
                  title: "Manage therapist",
                  description:
                    "Manage and assign therapist to specific client.",
                  label: "Update",
                  disabled: !_vm.verifiedManageTherapistInput,
                  submitLoading: _vm.manageTherapistLoading
                },
                on: {
                  "backdrop-close": function($event) {
                    _vm.manageTherapistOpened = false
                  },
                  "backdrop-action": _vm.onManageTherapist
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex flex-col gap-4 px-8",
                    style: { width: "40rem" }
                  },
                  [
                    _c("BlSearchSelect", {
                      attrs: {
                        asterisk: "",
                        label: "Client's name",
                        options: [
                          { value: _vm.client.id, label: _vm.client.name }
                        ],
                        disabled: ""
                      },
                      model: {
                        value: _vm.client.id,
                        callback: function($$v) {
                          _vm.$set(_vm.client, "id", $$v)
                        },
                        expression: "client.id"
                      }
                    }),
                    _vm._v(" "),
                    _c("BlSearchBox", {
                      attrs: {
                        type: "user",
                        label: "Assign to",
                        placeholder: "Type your therapist's name",
                        options: _vm.manageTherapistInput.existingUsers.map(
                          function(i) {
                            return {
                              value: i.id,
                              label: i.name
                            }
                          }
                        ),
                        fetchProperty: {
                          url:
                            "/api/v1/users?sort=name_asc&status=active&query=",
                          dataKey: "users",
                          countKey: "total_users",
                          optionKeys: { value: "id", label: "name" }
                        }
                      },
                      on: {
                        change: function($event) {
                          _vm.manageTherapistInput.userIds = $event
                        }
                      },
                      model: {
                        value: _vm.manageTherapistInput.userIds,
                        callback: function($$v) {
                          _vm.$set(_vm.manageTherapistInput, "userIds", $$v)
                        },
                        expression: "manageTherapistInput.userIds"
                      }
                    }),
                    _vm._v(" "),
                    _vm.diffManageTherapistCount > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex items-start gap-2 px-3 py-2 text-sm rounded bg-pending-100 text-pending"
                          },
                          [
                            _c("BlIcon", {
                              staticClass: "flex-shrink-0 w-6",
                              attrs: { icon: "warning", color: "pending" }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "flex-wrap" }, [
                              _vm._v(
                                "\n            You are about to remove\n            " +
                                  _vm._s(_vm.diffManageTherapistCount) +
                                  " therapist(s) from this client.\n            "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n            Once removed, they will no longer have access to this client's\n            information.\n            "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n            Don't worry, you can always assign them again in the future.\n          "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.deleteOpened
          ? _c("BlBackdrop", {
              attrs: {
                title: "Delete client",
                label: "Delete client",
                description: _vm.client.has_draft_sessions
                  ? "This client has draft or ongoing sessions. Are you sure you want to delete the client? This action is irreversible."
                  : "You are about to delete client " +
                    _vm.client.name +
                    ". Are you sure you want to proceed? This action is irreversible.",
                type: "error",
                empty: "",
                submitLoading: _vm.deleteLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteOpened = false
                },
                "backdrop-action": _vm.onRemoveClient
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "sticky left-0 z-50 flex items-center flex-shrink-0 h-10 gap-4 px-6 overflow-x-auto border-b bg-pure-white border-slate-400",
            style: { width: "calc(100vw - 0.5rem)" }
          },
          _vm._l(_vm.tabs, function(tab) {
            return _c(
              "div",
              {
                key: tab.target,
                staticClass:
                  "relative flex items-center flex-shrink-0 h-full gap-1 px-4 transition-all duration-300 rounded-t cursor-pointer bl-menu-tab-revamp hover:bg-hover-state",
                class: { "bl-tab-actived": tab.isActive },
                on: {
                  click: function($event) {
                    return _vm.changeTab(tab.target)
                  }
                }
              },
              [
                tab.isActive
                  ? _c("BlTextSubtitle2", { attrs: { text: tab.label } })
                  : _c("BlTextBody1", { attrs: { text: tab.label } }),
                _vm._v(" "),
                tab.count
                  ? _c("BlBubbleCount", {
                      attrs: { count: tab.count, minified: "" }
                    })
                  : _vm._e()
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("TargetJobProgression"),
        _vm._v(" "),
        _vm.client
          ? _c(
              "div",
              {
                staticClass: "flex flex-col flex-grow",
                style: { minHeight: "calc(100vh - 4.5rem - 5rem - 0.5rem)" }
              },
              [
                !_vm.$route.params.tab
                  ? _c("ClientAbout", { attrs: { id: _vm.client.id } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.params.tab === "cumulative-graph"
                  ? _c("ClientCumulativeGraph", {
                      attrs: { id: _vm.client.id }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.params.tab === "recommendation"
                  ? _c("ClientRecommendation", { attrs: { id: _vm.client.id } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.params.tab === "target"
                  ? _c("ClientTarget", { attrs: { id: _vm.client.id } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.params.tab === "task-analysis"
                  ? _c("ClientTask", { attrs: { id: _vm.client.id } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.params.tab === "session"
                  ? _c("ClientSession", { attrs: { id: _vm.client.id } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.params.tab === "credit"
                  ? _c("ClientCredit", { attrs: { id: _vm.client.id } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.params.tab === "report"
                  ? _c("ClientReport", { attrs: { id: _vm.client.id } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.$route.params.tab === "file"
                  ? _c("ClientFile", {
                      attrs: {
                        id: _vm.client.id,
                        uploadProgress: _vm.uploadProgress
                      },
                      on: {
                        "set-upload-progress": function($event) {
                          _vm.uploadProgress = $event
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.uploadProgress.length
          ? _c("div", { staticClass: "fixed z-50 right-6 bottom-6 w-128" }, [
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center gap-4 px-6 cursor-pointer h-14 rounded-t-3xl bg-light-purple-300",
                  class: { "rounded-b-3xl": !_vm.uploadChevronOpened },
                  on: {
                    click: function($event) {
                      _vm.uploadChevronOpened = !_vm.uploadChevronOpened
                    }
                  }
                },
                [
                  _c("BlIcon", {
                    staticClass: "w-5 h-5 transition-all duration-300",
                    style: { rotate: !_vm.uploadChevronOpened ? "180deg" : "" },
                    attrs: { icon: "chevron-down", color: "secondary" }
                  }),
                  _vm._v(" "),
                  _vm.uploadInProgress
                    ? _c("BlTextSubtitle2", {
                        staticClass: "text-pure-white",
                        attrs: {
                          text:
                            "Uploading " +
                            _vm.uploadProgress.filter(function(i) {
                              return i.started
                            }).length +
                            "/" +
                            _vm.uploadProgress.length +
                            " file(s)"
                        }
                      })
                    : _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-between w-full"
                        },
                        [
                          _c("BlTextSubtitle2", {
                            staticClass: "text-pure-white",
                            attrs: {
                              text: _vm.uploadedCount + " file(s) uploaded"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass: "w-5 h-5",
                            attrs: {
                              icon: "close",
                              color: "secondary",
                              clickable: ""
                            },
                            on: { clicked: _vm.onClearProgress }
                          })
                        ],
                        1
                      )
                ],
                1
              ),
              _vm._v(" "),
              _vm.uploadChevronOpened
                ? _c(
                    "div",
                    {
                      staticClass:
                        "px-6 py-4 overflow-y-auto border bg-pure-white border-slate-400 rounded-b-3xl",
                      style: { maxHeight: "75vh" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "To keep your upload active, please stay on this page. Moving within Blüm will stop the process, and any files that haven't finished uploading will be lost."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.uploadProgress, function(progress) {
                            return _c(
                              "div",
                              {
                                key: progress.name,
                                staticClass:
                                  "flex items-center justify-between gap-4 px-3 py-3 border-b"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex flex-col gap-1 truncate"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center gap-1 truncate",
                                        attrs: { title: progress.name }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "truncate" },
                                          [
                                            _c("BlTextSubtitle3", {
                                              attrs: { text: progress.name }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "flex-shrink-0 w-1 h-1 rounded bg-slate-600"
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          staticClass:
                                            "flex-shrink-0 text-slate-600",
                                          attrs: {
                                            text: _vm.getFileSize(progress.size)
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    progress.exceed_limit
                                      ? _c("BlTextBody2", {
                                          staticClass:
                                            "flex-shrink-0 text-slate-600",
                                          attrs: {
                                            text:
                                              "File exceeds 25 MB and cannot be uploaded."
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-center justify-end flex-shrink-0 gap-2 w-14"
                                  },
                                  [
                                    progress.uploading
                                      ? _c("div", {
                                          staticClass: "blum-loader-btn"
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !progress.uploading &&
                                    (!progress.started ||
                                      !progress.success ||
                                      progress.exceed_limit)
                                      ? _c("BlIcon", {
                                          staticClass: "w-4 h-4",
                                          attrs: {
                                            icon: "close",
                                            clickable: ""
                                          },
                                          on: {
                                            clicked: function($event) {
                                              return _vm.onRemoveProgress(
                                                progress
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    progress.success
                                      ? _c("BlIcon", {
                                          staticClass: "w-4 h-4",
                                          attrs: {
                                            icon: "check-circle",
                                            color: "success-4"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "absolute z-10 grid w-full h-full place-items-center" },
      [_c("div", { staticClass: "blum-loader" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b49f0a3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b49f0a3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/Client.vue
// module id = null
// module chunks = 